import React from 'react';
import styled from 'styled-components';
import {
  boxShadow, maxWidth, primaryHeadingColor, retina, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { TOOLTIP_BELTS, VIDEO_BELTS } from 'Utils/Constants';

const Wrapper = styled.div<{ beltShadow: string }>`
  border-radius: 8px;
  padding: 10px 20px;
  height: 100%;
  box-shadow: 0px 0px 15px 2px ${(props) => props.beltShadow}; 
  display: flex;
  flex-direction: column;
  align-items: center;
  .heading {
     margin-right: auto;
     font-size: 28px;
     font-family: ${secondaryFont};
     font-weight: ${wMBold};
     color: ${primaryHeadingColor};
     margin-bottom: 0px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 20px;
     }
   }
  video{
    margin: 0 auto;
  }
`;

type Props = {
  beltShadow: string,
  beltTitle: string,
  beltImage: string,
  loading?: boolean,
} | typeof defaultProps;

const defaultProps = {
  beltShadow: `${boxShadow}`,
  beltTitle: '',
  beltImage: '',
  loading: false,
};

const BeltWidget = function BeltWidget(props: Props) {
  const {
    beltShadow, beltImage, loading, beltTitle,
  } = props;
  return (
    loading ? <SkeletonCustom height="348px" width="100%" diameter="12px" />
      : (
        <Wrapper beltShadow={beltShadow}>
          <h1 className="heading d-flex align-items-center">
            {beltTitle}
            <HeadingWithToolTip
              toolTipText={TOOLTIP_BELTS}
              videoLink={VIDEO_BELTS}
            />
          </h1>
          <video width="100%" autoPlay loop muted playsInline>
            <source src={beltImage} type="video/mp4" />
          </video>
        </Wrapper>
      )
  );
};

BeltWidget.defaultProps = defaultProps;
export default BeltWidget;
